import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios';

import Carousel3d from 'vue-carousel-3d';

Vue.use(Carousel3d);
Vue.prototype.$axios=axios;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app')
